import React, { useState } from 'react';
import styled from 'styled-components';
import EditAndSaveRow from 'shared/components/Feedback/FiltersDropdown/EditAndSaveRow';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactFilterModal from 'shared/design-system/components/TrueImpactFilterModal';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { feedbackTemplates } from './tempData';

interface FeedbackTemplateModalProps {
  handleTextChange: (text: string) => unknown;
}

const StyledButtonTrueImpactText = styled(TrueImpactText)`
  cursor: pointer;
  text-align: center;
  margin-top: 18px;
  margin-bottom: 5px;
`;

const StyledDiv = styled.div`
  .sub-section {
    margin-bottom: ${SPACERS.small};
  }
`;

const FeedbackTemplateModal: React.FC<FeedbackTemplateModalProps> = ({
  handleTextChange,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');
  const keys = Object.keys(feedbackTemplates);
  return (
    <>
      <StyledButtonTrueImpactText
        variant="body-small"
        color="ctaPrimary"
        onClick={() => setOpen(true)}
        className="view-template-button"
      >
        View/edit all templates
      </StyledButtonTrueImpactText>
      <TrueImpactFilterModal
        open={open}
        heading="Feedback Templates"
        onClose={() => setOpen(false)}
        searchText={searchText}
        label="Feedback Template"
        description="True Impact Staff can choose a template to add feedback response"
        onSearchTextChange={setSearchText}
      >
        <StyledDiv>
          {keys.length ? (
            keys.map((k, i) => (
              <div key={i}>
                <TrueImpactText variant="heading">{k}</TrueImpactText>
                {feedbackTemplates[k]?.map((a, j) => (
                  <div key={j} className="sub-section">
                    <TrueImpactText
                      color="grayDark"
                      variant="heading-subheading"
                    >
                      {a.name}
                    </TrueImpactText>
                    {a.templates.map((b, k) =>
                      b.name
                        .toLocaleLowerCase()
                        .includes(searchText.toLocaleLowerCase()) ? (
                        <EditAndSaveRow
                          key={k}
                          createdDate={b.createdAt}
                          description={b.description}
                          onClick={() => handleTextChange(b.description)}
                          onDelete={() => null}
                          onSave={(title, description) =>
                            console.log(title, description)
                          }
                          title={b.name}
                          userName={b.userName}
                        />
                      ) : null,
                    )}
                  </div>
                ))}
              </div>
            ))
          ) : (
            <div>No Templates found.</div>
          )}
        </StyledDiv>
      </TrueImpactFilterModal>
    </>
  );
};

export default FeedbackTemplateModal;
